var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteActivityLog(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89367 0.259201L6.89538 1.45842L1.85632 1.45185C1.73446 1.45169 1.6187 1.49646 1.53521 1.57253C1.45228 1.64826 1.40754 1.7489 1.40768 1.85166L1.42484 13.8516C1.42499 13.9545 1.46981 14.0561 1.55317 14.1321C1.63688 14.2084 1.75276 14.2525 1.87463 14.2526L15.0445 14.2698C15.1664 14.2699 15.2822 14.2261 15.3657 14.1501C15.4488 14.0743 15.4933 13.9729 15.4932 13.87L15.4873 9.77037L16.7842 9.77206L16.7901 13.8717C16.7907 14.2992 16.605 14.707 16.277 15.0058C15.9494 15.3042 15.5065 15.4706 15.0463 15.47L1.87635 15.4528C1.41607 15.4522 0.972713 15.2847 0.644237 14.9854C0.315446 14.6858 0.128578 14.2775 0.127966 13.85L0.110803 1.84997C0.110201 1.42246 0.295902 1.01463 0.623828 0.715873C0.951433 0.417511 1.39441 0.252034 1.85461 0.252634L6.89367 0.259201Z",
    fill: "#F3F1FF",
    stroke: "#F3F1FF",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1227 0.271608C16.2917 0.27194 16.4557 0.332677 16.578 0.444076C16.7007 0.555885 16.7717 0.709773 16.772 0.872062L16.7771 4.47167L15.4793 4.46998L15.475 1.46998L12.183 1.46569L12.1813 0.266472L16.1227 0.271608Z",
    fill: "#F3F1FF",
    stroke: "#F3F1FF",
    strokeWidth: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.731 0.385303L16.6561 1.22839L5.54978 11.3468L4.62461 10.5037L15.731 0.385303Z",
    fill: "#F3F1FF",
    stroke: "#F3F1FF",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteActivityLog);
export default __webpack_public_path__ + "static/media/WhiteActivityLog.d62dfb2cf49e83ed23e4f9a6a69296f3.svg";
export { ForwardRef as ReactComponent };